module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-backplates-remnants.fca903c9.png";